import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiOrdersProducts } from 'Services/StoreUserService'

export const getData = createAsyncThunk('storeUser/analysis/orders/getData', async datas => {
    const { data } = await apiOrdersProducts(datas)
    return data
})

export const ordersSlice = createSlice({
    name: 'storeUser/analysis/orders',
    initialState: {
        loading: true,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
    },
})

export const { setData, setTableData } = ordersSlice.actions

export default ordersSlice.reducer
